import React from 'react';
import PropTypes from 'prop-types';

export const accessor = (row, head) => row[head];

function DefaultCellRenderer({ row, head }) {
  const { label } = head;
  const value = accessor(row, head.field);

  return (
    <td className={`DynamicTableData__Cell__${(label || '').replace(' ', '_')}`}>
      {value}
    </td>
  );
}

DefaultCellRenderer.propTypes = {
  row: PropTypes.shape().isRequired,
  head: PropTypes.shape().isRequired,
};

export default DefaultCellRenderer;